import ReactDOM from "react-dom"
import React from 'react';
import { Router } from "react-router-dom"
import { createBrowserHistory } from "history"

import * as Sentry from "@sentry/react"
import { Integrations } from "@sentry/tracing"

import "./index.scss"
import App from "./App"

const history = createBrowserHistory()

Sentry.init({
  dsn:
    process.env.REACT_APP_SENTRY_DSN ??
    "https://d740ab91718e4d9bbf139fc3925b1982@o723072.ingest.sentry.io/6547773",
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
    }),
  ],
  tracesSampleRate: 0.1,
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
  release: `busp@${process.env.REACT_APP_SENTRY_VERSION}`,
  admin: true,
  beforeSend: (event, hint) => {
    const { exception, tags, event_id: eventId } = event

    if (exception && !tags?.noFallback) {
      history.push(`/error/${eventId}`)
    }

    return event
  },
})

// import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  // <React.StrictMode>
  <Sentry.ErrorBoundary>
    <Router history={history}>
      <App />
    </Router>
  </Sentry.ErrorBoundary>,
  // </React.StrictMode>,
  document.getElementById("root")
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
